import { render, staticRenderFns } from "./ActionsCol.vue?vue&type=template&id=2a7649ce&"
import script from "./ActionsCol.vue?vue&type=script&lang=js&"
export * from "./ActionsCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports